import { useMemo } from 'react';
import { matchRoutes, useLocation } from 'react-router';
import { router } from '../../../routes/router';
import { screenFromMatches, YbotScreen } from './ybotScreenLib';

/**
 * The screen a prompt is being sent from. Matched against the router's own route table, so the
 * pattern is the one the app actually declares.
 *
 * The import of `router` closes a module cycle (router -> PageLayout -> YbotDock -> here ->
 * router). It holds because `router.routes` is read while rendering, never while the module is
 * evaluated, and it is confined to this hook so the dock's own tests mock the hook rather than the
 * router.
 */
export const useYbotScreen = (): YbotScreen | undefined => {
  const location = useLocation();

  return useMemo(
    () => screenFromMatches(matchRoutes(router.routes, location.pathname), location),
    [location],
  );
};
